/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 20/11/2021
 */

export let defaultPalette = [
	'#409EFF',
	'#67C23A',
	'#E6A23C',
	'#F56C6C',
	'#909399',
	'#303133',

	'#FF4F03',
	'#B88562',
	'#E55CFF',
	'#8247F5',
	'#0099FF',
	'#09E8F0',
	'#17E885',
	'#CCF002',
	'#F8E436',
	'#FFA603',
	'#658BA8',
	'#969696'
];

// '#a4bdfc',
// '#7ae7bf',
// '#dbadff',
// '#ff887c',
// '#fbd75b',
// '#ffb878',
// '#409EFF',
// '#e1e1e1',
// '#5484ed',
// '#51b749',
// '#dc2127'

let defaultColorPickerPalette = [
	'#039be5',
	'#33B679',
	'#0b8043',
	'#7986CB',
	'#3f51b5',
	'#F6BF26',
	'#e67c73',
	'#f5511d',
	'#d60000',
	'#8E24AA',
	'#616161',

	// '#409EFF',
	// '#33B679',
	// '#0A8043',
	// '#7986CB',
	// '#8E24AA',
	// '#3F51B5',
	// '#F6BF26',
	// '#E67C73',
	// '#F4511E',
	// // '#909399',
	//
	// // '#FF4F03',
	// '#D50002',
	// // '#17E885',
	// '#616161',
	// '#FFA603',
	// '#658BA8',
	// '#969696'
]


let expandedColorPickerPalette = [
	// Base Color: #039be5 (Blue)
	'#039be5',
	'#A2D4F4', // Light Blue

	// Base Color: #33B679 (Green)
	'#33B679',
	'#8ADCAB', // Light Green

	// Base Color: #0b8043 (Dark Green)
	'#0b8043',
	'#A1D7B2', // Soft Green

	// Base Color: #7986CB (Soft Blue)
	'#7986CB',
	'#E0E4F2', // Very Light Soft Blue

	// Base Color: #3f51b5 (Indigo)
	'#3f51b5',
	'#C1C6EB', // Light Indigo

	// Base Color: #F6BF26 (Yellow)
	'#F6BF26',
	'#FAD98D', // Light Yellow

	// Base Color: #e67c73 (Red-Pink)
	'#e67c73',
	'#F6DBD8', // Soft Pink

	// Base Color: #f5511d (Orange)
	'#f5511d',
	'#FCCBB9', // Light Orange

	// Base Color: #d60000 (Red)
	'#d60000',
	'#F4A3A3', // Soft Red

	// Base Color: #8E24AA (Purple)
	'#8E24AA',
	'#DCB3E7', // Light Purple

	// Base Color: #616161 (Gray)
	'#616161',
	'#DCDCDC' // Light Gray
]
// [
// 	'#D50000',
// 	'#E67C73',
// 	'#F4511E',
// 	'#F6BF26',
// 	'#33B679',
// 	'#0B8043',
// 	'#039BE5',
// 	'#3F51B5',
// 	'#7986CB',
// 	'#8E24AA',
// 	'#616161',
//
// 	'#fe4500',
// 	'#F39C19',
// 	// '#ffd700',
// 	'#90ee90',
// 	'#00ced1',
// 	'#1e90ff',
// 	'#c71585',
// 	'#222F3D',
// 	'#BDC3C8',
// 	'#8E43AD'
// ]


const PaletteEnum = Object.freeze({
	COLOR_PICKER_PRIMARY: defaultColorPickerPalette[0],
	PRIMARY: defaultPalette[0],
	SUCCESS: defaultPalette[1],
	WARNING: defaultPalette[2],
	DANGER: defaultPalette[3],
	DISABLED: defaultPalette[4],
	SUCCESS_LIGHT: "#CCF002",
	DEFAULT_STAR_COLOR: "#f7ba2a",
})

export {
	PaletteEnum,
	defaultColorPickerPalette,
	expandedColorPickerPalette,
}
